import { InputBoX, MenuOption, TableHead, SearchData } from "../../../../common/dataClass/Default"

/**汇总看板搜索类 */
class BoardSearchData extends SearchData{
  constructor() {
    super()
    /**国家索引 */
    this.countrySite = ''
    /**店铺索引 */
    this.store = ''
    /**listing负责人 */
    this.listingPerson = ''
    /**搜索分类 */
    this.sort = ''
    /**时间周期 */
    this.timePeriod = 0
    /**日期 */
    this.time = ''
  }
}

/**报告上传数据 */
class ReportUpload{
  constructor() {
    /**收汇数据报告 */
    this.collectionData = ''
    /**亚马逊账户剩余余额 */
    this.blance = null
    /**详情页面销售和流量 */
    this.trafficVolume = {}
    /**管理亚马逊物流库存 */
    this.logisticsInventory = {}
    /**广告费 */
    this.advertisement = {}
    /**已完成的销售订单 */
    this.salesOrder = null
    /**亚马逊配送货件 */
    this.deliveryShipment = null
    /**月度仓储费 */
    this.monthlyStorageFee = null
    /**亚马逊卖家退货 */
    this.returnGoods = null
    /**移除订单详细 */
    this.removeOrder = null
    /**库存分类帐 */
    this.inventory = null
    /**超龄库存附加费报告 */
    this.longTermStorageFee = null
    /**换货 */
    this.exchangeOfGoods = null
    /**赔偿数量 */
    this.compensation = null
  }
}

/**汇总看板搜索输入框类 */
class BoardSearchInputBox extends InputBoX{
  constructor(type, name, data, obj = {pla: ''}){
    super(type, name, data, obj)
  }
}

/**选择子项 */
class BoardSelectOption extends MenuOption{
  constructor(name, id) {
    super(name, id)
  }
}

/**图表子项 */
class EchartOption extends MenuOption{
  constructor(type, name, id, obj = { updataTime: null, list: {}, echartOption: {} }){
    super(name, id)
    /**更新时间 */
    this.updataTime = obj.updataTime != null ? obj.updataTime : null
    /**汇总项 */
    this.list = Object.prototype.hasOwnProperty.call(obj, 'list') ? obj.list : {}
    /**图标类型 */
    this.type = type
    /**图表参数 */
    this.echartOption = Object.prototype.hasOwnProperty.call(obj, 'echartOption') ? obj.echartOption : {}
    /**表头 */
    this.tableHead = Object.prototype.hasOwnProperty.call(obj, 'tableHead') ? obj.tableHead: []
    /**表格宽度 */
    this.tableWidth = Object.prototype.hasOwnProperty.call(obj, 'tableWidth') ? obj.tableWidth: 0
  }
}

/**汇总项 */
class SummaryItem{
  constructor(name, id, num, previousNum) {
    /**标题 */
    this.name = name
    /**索引 */
    this.id = id
    /**对应数量 */
    this.num = num
    /**上期数量 */
    this.previousNum = previousNum
  }
}

/**看板表头 */
class BoardTableHead extends TableHead{
  constructor(name, prop, width) {
    super(name, prop, width)
  }
}

/**文件上传输入框 */
class ReportUploadInputBox extends InputBoX{
  constructor(type, name, data, obj = { isRequired: false, tips: '', fileType: '' }) {
    super(type, name, data, obj)
    this.isRequired = obj.isRequired ? obj.isRequired : false
    this.tips = obj.tips ? obj.tips : ''
    /**文件类型 */
    this.fileType = obj.fileType ? obj.fileType : ''
  }
}

/**看板创建类 */
class BoardInputNewModule{
  /**顶部搜索输入模块 */
  static NEWSEARCHINPUT(){
    let obj = {
      country: new BoardSearchInputBox('select', '国家站点', 'countrySite', { pla: '全部国家' }),
      store: new BoardSearchInputBox('select', '店铺', 'store', { pla: '全部店铺' }),
      listing: new BoardSearchInputBox('select', 'listing', 'listingPerson', { pla: '全部Lisitng负责人' }),
      sort: new BoardSearchInputBox('sort', '分类', 'sort'),
      timePeriod: new BoardSearchInputBox('period', '时间周期', 'period'),
      time: new BoardSearchInputBox('time', '时间段', 'time')
    }
    return obj
  }
  /**时间周期数组 */
  static NEWTIMEPERIODARRAY(){
    let arr = [
      new BoardSelectOption('最近三期', 0),
      new BoardSelectOption('最近两期', 1),
      new BoardSelectOption('本期', 2),
      new BoardSelectOption('今年', 3),
    ]
    return arr
  }
  /**汇总图表 */
  static NEWSUMMARYECHARTSARRAY(){
    let reportList = {
      order: new SummaryItem('总订单量', 'order', 0, 0),
      sale: new SummaryItem('总销售量', 'sale', 0, 0),
      sales: new SummaryItem('总销售额', 'sales', 0, 0),
      defective: new SummaryItem('总坏品退货量', 'defective', 0, 0),
      nonDefective: new SummaryItem('总非坏品退货量', 'nonDefective', 0, 0),
      return: new SummaryItem('总退货额', 'return', 0, 0)
    }
    let costList = {
      income: new SummaryItem('总收入', 'income', '0.00', null),
      pay: new SummaryItem('总支出', 'pay', '0.00', null),
      grossProfit: new SummaryItem('毛利润', 'grossProfit', '0.00', null),
      rate: new SummaryItem('利润率', 'rate', '0%', null)
    }
    let profitList = {
      pay: new SummaryItem('总支出', 'pay', 0, null),
      totalProfit: new SummaryItem('总利润', 'totalProfit', 0, null),
    }
    let stockList = {
      stock: new SummaryItem('库存总价值', 'stock', 0, null),
      SKU: new SummaryItem('需补货SKU数量', 'SKU', 0, null),
    }
    let reportEchartOption = {
      xAxis: { type: 'category' },
      yAxis: { type: 'value' },
      series: [{
        data: [0, 0.2, 0.6, 0.8, 1],
        type: "line",
      }]
    }
    let costEchartOption = {
      tooltip: {
        trigger: "item",
      },
      legend: {
        orient: "vertical",
        right: "right",
      },
      series: [{
        data: [
          { value: 50, name: "毛利润" },
          { value: 50, name: "总支出" },
        ],
        type: "pie",
        radius: '60%',
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      }]
    }
    let saleTableHead = [
      new BoardTableHead('图片', 'img', '60'),
      new BoardTableHead('ASIN', 'asin', '180'),
      new BoardTableHead('商品销售额', 'sales', '80'),
      new BoardTableHead('销售量', 'sale', '60'),
    ]
    let profitTableHead = [
      new BoardTableHead('图片', 'img', '60'),
      new BoardTableHead('ASIN', 'asin', '180'),
      new BoardTableHead('采购', 'procurement', '40'),
      new BoardTableHead('物流', 'logistics', '40'),
      new BoardTableHead('其它站外支出', 'otherExpenses', '100'),
      new BoardTableHead('亚马逊广告支出', 'advertisingExpenditure', '100'),
      new BoardTableHead('亚马逊配送及佣金', 'commission', '120'),
      new BoardTableHead('其它亚马逊费用', 'cost', '100'),
      new BoardTableHead('利润', 'profit', '80'),
    ]
    let stockTableHead = [
      new BoardTableHead('图片', 'img', '60'),
      new BoardTableHead('ASIN', 'asin', '180'),
      new BoardTableHead('生产中数量', 'procurement', '80'),
      new BoardTableHead('中转仓的库存量', 'logistics', '120'),
      new BoardTableHead('运输中数量', 'otherExpenses', '100'),
      new BoardTableHead('已入仓未上架数量', 'advertisingExpenditure', '120'),
      new BoardTableHead('在售数量', 'commission', '80'),
      new BoardTableHead('总库存量', 'cost', '80'),
      new BoardTableHead('总库存价值', 'profit', '100'),
    ]
    let obj = {
      report: new EchartOption('line', '销售报告', 'report', { updataTime: '', list: reportList, echartOption: reportEchartOption }),
      sale: new EchartOption('table', '销量榜', 'sale', { tableHead: saleTableHead, tableWidth: '368' }),
      cost: new EchartOption('pie', '成本利润状况', 'cost', { list: costList, echartOption: costEchartOption }),
      profit: new EchartOption('table', '利润榜', 'profit', { updataTime: '', list: profitList, tableHead: profitTableHead, tableWidth: '810' }),
      stock: new EchartOption('table', '库存量及库存价值', 'stock', { updataTime: '', list: stockList, tableHead: stockTableHead, tableWidth: '810' }),
    }
    return obj
  }
  /**创建进度条数据 */
  static NEWPROGRESSARRAY(){
    let arr = [
      '亚马逊店铺后台下载及保存数据报告',
      '下拉选择汇总日期',
      '选择店铺及区域分别对应上传汇总数据报告',
      '点击“汇总统计”',
    ]
    return arr
  }
  /**顶部文件 */
  static NEWTOPFILEINPUT(){
    let arr = [
      new ReportUploadInputBox('file', '收汇数据报告', 'collectionData', { isRequired: true }),
      new ReportUploadInputBox('file', '亚马逊账户剩余余额', 'blance', { isRequired: true }),
    ]
    return arr
  }
  /**区域文件 */
  static NEWAREAFILEINPUT(){
    let arr = [
      new ReportUploadInputBox('file', ' 1.详情页面销售和流量 (按子商品) DetailPage Sales and Traffic By Child Item', 'trafficVolume', { isRequired: true, fileType: 'FT0004' }),
      new ReportUploadInputBox('file', ' 2.管理亚马逊物流库存 Manage FBA Inventory', 'logisticsInventory', { fileType: '' }),
      new ReportUploadInputBox('file', ' 3.广告费 Advertisement Fees', 'advertisement', { tips: '(注: 本期如没数据,可不上传报告)', fileType: 'FT0011' }),
    ]
    return arr
  }
  /**左侧文件 */
  static NEWLEFTFILEINPUT(){
    let arr = [
      new ReportUploadInputBox('file', ' 4.已完成的销售订单 Completed Sales Orders', 'salesOrder', { tips: '(注: 本期如没数据,可不上传报告)', fileType: 'FT0005' }),
      new ReportUploadInputBox('file', ' 5.亚马逊配送货件 Amazon Fulfilled Shipments', 'deliveryShipment', { tips: '(注: 当本期没有发生配送将没下载的数据报告,该项可不上传)', fileType: 'FT0006' }),
      new ReportUploadInputBox('file', ' 6.月度仓储费 Monthly Storage Fees', 'monthlyStorageFee', { tips: '(注: 本期如没数据,可不上传报告)', fileType: 'FT0007' }),
      new ReportUploadInputBox('file', ' 7.亚马逊物流买家退货 Returns', 'returnGoods', { tips: '(注: 本期如没数据,可不上传报告)', fileType: 'FT0008' }),
      new ReportUploadInputBox('file', ' 8.移除订单详情 Removal Order Detail', 'removeOrder', { tips: '(注: 本期如没数据,可不上传报告)', fileType: 'FT0009' }),
    ]
    return arr
  }
  /**右侧文件 */
  static NEWRIGHTFILEINPUT(){
    let arr = [
      new ReportUploadInputBox('file', ' 9.库存分类帐 Inventory Ledger', 'inventory', { tips: '(注: 本期如没数据,可不上传报告)', fileType: 'FT0010' }),
      new ReportUploadInputBox('file', ' 10.超龄库存附加费报告 Aged Inventory Surcharge Report', 'longTermStorageFee', { tips: '(注: 本期如没数据,可不上传报告)', fileType: 'FT0012' }),
      new ReportUploadInputBox('file', ' 11.换货 Replacement', 'exchangeOfGoods', { tips: '(注: 本期如没数据,可不上传报告)', fileType: 'FT0013' }),
      new ReportUploadInputBox('file', ' 12.赔偿数量 Reimbursements', 'compensation', { tips: '(注: 本期如没数据,可不上传报告)', fileType: 'FT0014' }),
    ]
    return arr
  }
}

export {
  BoardSearchData, BoardInputNewModule, BoardSelectOption, ReportUpload
}
